import { render, staticRenderFns } from "./PendingBatchPaymentDetails.vue?vue&type=template&id=73e1cbb2&scoped=true"
import script from "./PendingBatchPaymentDetails.vue?vue&type=script&lang=js"
export * from "./PendingBatchPaymentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e1cbb2",
  null
  
)

export default component.exports